// extracted by mini-css-extract-plugin
export default {"gradientBackground":"styles_gradientBackground__gap6I","countColumn":"styles_countColumn__OQjlL","rightBorder":"styles_rightBorder__JfIfs"};